import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { AppConfigService } from './app-config.service';
import { ConfigService } from '../models/ConfigService';

@Injectable({
    providedIn: 'root',
  })
export class DataService {
    configData: any = null;
    token:any=null;
    mainusername=""
    constructor(private http: HttpClient , private config: ConfigService) {
        this.configData = this.config.getSettings("ApiUrl")
       
        
    }
    getdata_insight(auth_token: any){
        console.log('call')
        
        const requestHeader = new HttpHeaders({
            //'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        
        
       
    
        //return this.http.post(thi.configData+"JobProfileMatching")
        return this.http.post(this.configData + "getsmartins_filter",'',{
            'headers':requestHeader,
            // 'reportProgress': true,
            // 'observe': 'events'
        } );
    }
    
    public get_smrtins_summarydata(auth_token:any,formdata:any)
    {
        const headers = new HttpHeaders().set('Authorization','Bearer '+ `${auth_token}`);
        return this.http.post(this.configData+"smartins_getdata",formdata,{ headers });
    
    }
    

    public getData(auth_token: any) {
        const headers = new HttpHeaders().set('Authorization','Bearer '+ `${auth_token}`);
        // const headers = new HttpHeaders().set({
        //     'Content-Type': 'application/json',
        //     'Access-Control-Allow-Origin'
        //     'Authorization': `Bearer ${auth_token}`
        //   })
        return this.http.get(this.configData,{ headers });
    }

    getdropdownlist(auth_token: any){
    
        const requestHeader = new HttpHeaders({
            //'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        
       
    
        //return this.http.post(thi.configData+"JobProfileMatching")
        return this.http.post(this.configData + "getJobProfileGroup",'',{
            'headers':requestHeader,
            // 'reportProgress': true,
            // 'observe': 'events'
        } );
    }

    Get_stopdict_data(auth_token:any,formData:any){
        const requestHeader = new HttpHeaders({
            //'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        console.log('call')
        return this.http.post(this.configData + "getstopwordlist", formData,{ });
          
    
    }

    GetToken_onbehalf(auth_token:any,formData:any){
        const requestHeader = new HttpHeaders({
            //'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        return this.http.post("https://hraseg-api.ciohosting.accenture.com/hr_charts/Generate_token_PBI", formData,{ 'headers': requestHeader  });
    }
    

    public GetDataForFilters(auth_token: any,colname: string,Filters: string,attritionType: string) {
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            "col": colname ,
            "UserKey": Filters,
            "attritiontype": attritionType
           
        });
        //console.log(body);
        return this.http.post(this.configData + "DistinctVal", body,{ 'headers': requestHeader });
       
    }

    GetDataForDropDowns(auth_token: any,attritiontype: string) {
       // const headers = new HttpHeaders().set('Authorization', `${auth_token}`);
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        
        var body = JSON.stringify({
           "attritiontype" : attritiontype
        });
        //console.log(body);
        return this.http.post(this.configData + "BindDD", body, { 'headers': requestHeader } );
    }

    getDataForBarNumber(auth_token: any,Selyaxis: any, X_axis: any,SelAggMea: any, SortOrder: any, SortType: any,Userkey: any,where_condition: any) {
        //console.log(Selyaxis, X_axis,SelAggMea, SortOrder, SortType,Userkey);
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            "x_axis": X_axis ,
            "y_axis": Selyaxis,
            "AggMeasures": SelAggMea,
            "SortOrder": SortOrder,
            "SortType": SortType,
            "UserKey":Userkey,
            "where_condition" : where_condition

        });
        //console.log(body);
        return this.http.post(this.configData + "getdata", body, { 'headers': requestHeader });
    }


    getDataForBarPercentage(auth_token: any,Selyaxis: any, X_axis: any,SelAggMea: any, SortOrder: any, SortType: any,Userkey: any,where_condition: any) {
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            "x_axis": X_axis ,
            "y_axis": Selyaxis,
            "AggMeasures": SelAggMea,
            "SortOrder": SortOrder,
            "SortType": SortType,
            "UserKey":Userkey,
            "where_condition":where_condition

           
        });
        //console.log("percentage",body);
        return this.http.post(this.configData + "getbarpercent", body,{ 'headers': requestHeader });
    }

    getDataForStack(auth_token: any,Selyaxis: any, x_axis: any, SelAggMea: any, SortOrder: any, SortType: any,Userkey: any,where_condition: any) {
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            "UserKey":Userkey,
            "y_axis": Selyaxis ,
            "x_axis": x_axis,
            "AggMeasures": SelAggMea,
            "SortOrder": SortOrder,
            "SortType": SortType,
            "where_condition":where_condition

           
        });
       // console.log(body);
        return this.http.post(this.configData + "getstack", body,{ 'headers': requestHeader });
      
    }
    

    GetDataForDecisionVars(auth_token: any) {
        // const headers = new HttpHeaders().set('Authorization', `${auth_token}`);
         const requestHeader = new HttpHeaders({
             'Content-Type': 'application/json',
             'Authorization': 'Bearer '+ `${auth_token}`,
             'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
            
         });
         
         var body = JSON.stringify({
            
         });
         //console.log(body);
         return this.http.post(this.configData + "BindDDDecision", body, { 'headers': requestHeader } );
     }


     GetDataForDecision(auth_token: any,Dep_var: string, Indep_var: string, leaf: number,depth: string,Userkey: string) {
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            "UserKey":Userkey,
            "Dep_var": Dep_var ,
            "Indep_var": Indep_var,
            "leaf": leaf,
            "depth": depth
           
        });
       // console.log(body);
        return this.http.post(this.configData + "getdecisionTreeData", body,{ 'headers': requestHeader });
      
    }
    

    getDataForCombo(auth_token: any,Selyaxis: any, X_axis: any,SelAggMea: any, SortOrder: any, SortType: any,Sec_y_axis: any,Userkey: any,where_condition: any) {
        //console.log(Selyaxis, X_axis,SelAggMea, SortOrder, SortType,Userkey);
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            "x_axis": X_axis ,
            "y_axis": Selyaxis,
            "AggMeasures": SelAggMea,
            "SortOrder": SortOrder,
            "SortType": SortType,
            "UserKey":Userkey,
            "Sec_y_axis":Sec_y_axis,
            "where_condition" : where_condition

        });
        //console.log(body);
        return this.http.post(this.configData + "getcombo", body, { 'headers': requestHeader });
    }

    getDataForWhisker(auth_token: any,Selyaxis: any, X_axis: any, SelSec_X_axis: any, SelAggMea: any, SortOrder: any, SortType: any,Userkey: any,where_condition: any) {
        //console.log(Selyaxis, X_axis,SelAggMea, SortOrder, SortType,Userkey);
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            "x_axis": X_axis ,
            "y_axis": Selyaxis,
            "Sec_x_axis": SelSec_X_axis,
            "AggMeasures": SelAggMea,
            "SortOrder": SortOrder,
            "SortType": SortType,
            "UserKey":Userkey,
            "where_condition" : where_condition

        });
        console.log('datasent',body);
        return this.http.post(this.configData + "getwhisker", body, { 'headers': requestHeader });
    }

    BindQuestions(auth_token: any) {
        // const headers = new HttpHeaders().set('Authorization', `${auth_token}`);
         const requestHeader = new HttpHeaders({
             'Content-Type': 'application/json',
             'Authorization': 'Bearer '+ `${auth_token}`,
             'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
            
         });
         
         var body = JSON.stringify({
            
         });
         //console.log(body);
         return this.http.post(this.configData + "PopQues", body, { 'headers': requestHeader } );
     }


     startChat(auth_token: any,Chattext: any, Front_input: any, Flag: any) {
        // const headers = new HttpHeaders().set('Authorization', `${auth_token}`);
         const requestHeader = new HttpHeaders({
             'Content-Type': 'application/json',
             'Authorization': 'Bearer '+ `${auth_token}`,
             'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
            
         });
         
         var body = JSON.stringify({
            "Chattext": Chattext ,
            "Front_input": Front_input,
            "Flag": Flag
            
         });
         
         
         return this.http.post(this.configData + "startChat", body, { 'headers': requestHeader } );
     }


     GetDataForMarketlocation(auth_token: any,Analysis: any) {
        // const headers = new HttpHeaders().set('Authorization', `${auth_token}`);
         const requestHeader = new HttpHeaders({
             'Content-Type': 'application/json',
             'Authorization': 'Bearer '+ `${auth_token}`,
             'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
            
         });
         
         var body = JSON.stringify({
            "Analysis": Analysis 
            
         });
         //console.log(body);
         return this.http.post(this.configData + "Bindmarketloc", body, { 'headers': requestHeader } );
     }

     SaveuserUploadFIle(auth_token: any,formData: any){
        const requestHeader = new HttpHeaders({
            // 'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        
        //console.log('form ',FormData)
        return this.http.post(this.configData + "SaveUserUploadFile", formData );
     }

        

     SaveBookmarks(auth_token: any,SelectedColumns: any,SaveAppliedFilters: any,Displayscreen: any,username: any,SelBookmarkName: any){
        // const headers = new HttpHeaders().set('Authorization', `${auth_token}`);
         const requestHeader = new HttpHeaders({
             'Content-Type': 'application/json',
             'Authorization': 'Bearer '+ `${auth_token}`,
             'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
            
         });
         
         var body = JSON.stringify({
            "SelectedColumns": SelectedColumns,
            "SaveAppliedFilters" : SaveAppliedFilters,
            "Displayscreen": Displayscreen,
            "username" : username,
            "SelBookmarkName" : SelBookmarkName

            
         });
         console.log(body);
         return this.http.post(this.configData + "SaveDataForBookmarks", body, { 'headers': requestHeader } );
     }


     ShowBookmarks(auth_token: any,Displayscreen: any,username: any){
        // const headers = new HttpHeaders().set('Authorization', `${auth_token}`);
         const requestHeader = new HttpHeaders({
             'Content-Type': 'application/json',
             'Authorization': 'Bearer '+ `${auth_token}`,
             'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
            
         });
         
         var body = JSON.stringify({
            "Displayscreen": Displayscreen,
            "username" : username

            
         });
         //console.log(body);
         return this.http.post(this.configData + "ShowBookmarksList", body, { 'headers': requestHeader } );
     }


     DeleteBookmark(auth_token: any,username: any,Bookmarkname: any,Displayscreen: any){
        // const headers = new HttpHeaders().set('Authorization', `${auth_token}`);
         const requestHeader = new HttpHeaders({
             'Content-Type': 'application/json',
             'Authorization': 'Bearer '+ `${auth_token}`,
             'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
            
         });
         
         var body = JSON.stringify({
            "bookmarkname": Bookmarkname,
            "username" : username,
            "Displayscreen": Displayscreen

            
         });
         //console.log(body);
         return this.http.post(this.configData + "DeleteBookmarks", body, { 'headers': requestHeader } );
     }

     TextSummarizeData(auth_token: any,formData: any){
        //auth_token='';
        const requestHeader = new HttpHeaders({
           // 'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        
        console.log('form ',formData)
        // return this.http.post("http:localhost:5000/SaveUserUploadFile", formData,{
        //     reportProgress: true,
        //     observe: 'events'
        // } );
        for (var pair of formData.entries()) {
            console.log(pair[0]+ ', ' + pair[1]); 
        }
        
        //return this.http.post(thi.configData+"JobProfileMatching")
        return this.http.post(this.configData + "SummarizeText", formData,{
            'headers':requestHeader,
            // 'reportProgress': true,
            // 'observe': 'events'
        } );
    }

     submitPosTaggingData(auth_token: any,formData: any){
        const requestHeader = new HttpHeaders({
           // 'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        
        console.log('form ',formData)
        // return this.http.post("http:localhost:5000/SaveUserUploadFile", formData,{
        //     reportProgress: true,
        //     observe: 'events'
        // } );
        for (var pair of formData.entries()) {
            console.log(pair[0]+ ', ' + pair[1]); 
        }
        
        //return this.http.post(thi.configData+"JobProfileMatching")
        return this.http.post(this.configData + "getpostags", formData,{
            'headers':requestHeader,
            // 'reportProgress': true,
            // 'observe': 'events'
        } );
    }

    GetDataForWordcloud(auth_token: any,formData:any) {
        const requestHeader = new HttpHeaders({
            //'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        // var body = JSON.stringify({
        //     "SelTopWords": SelTopWords,
        //     "SelWordFrequency" : SelWordFrequency,
        //     "SelNgrams": SelNgrams ,
        //     "SelTextAnalysis" : SelTextAnalysis ,
        //     "exclude_stopwd" : exclude_stopwd ,
        //     "FileName":filename,
        //     "Username":username

        // });
        return this.http.post(this.configData + "getwordcloud", formData,{ 'headers': requestHeader });
      
    }


    GetDataForSelectedWord(auth_token: any,Ngrams: any,username: any,selval: any) {
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            "Ngrams": Ngrams,
            "username": username,
            "selval": selval

        });
        return this.http.post(this.configData + "GetDataForSelectedWord", body,{ 'headers': requestHeader });
      
    }


    GetDataForWordcloudForSentiments(auth_token: any,username: any,selval: any,SelTopWords: any,SelWordFrequency: any,SelNgrams: any,exclude_stopwd: any,SelTextAnalysis: any) {
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            "username": username,
            "sentimenttype": selval,
            "SelTopWords": SelTopWords,
            "SelWordFrequency" : SelWordFrequency,
            "SelNgrams": SelNgrams ,
            "exclude_stopwd" : exclude_stopwd ,
            "SelTextAnalysis" : SelTextAnalysis,
            "codetype": "senti"

        });
        return this.http.post(this.configData + "GetDataForWordcloudForSentiments", body,{ 'headers': requestHeader });
      
    }
   

    GetDataForTopicModelling(auth_token: any,SelTopics: any,SelWordFrequency: any,SelNgrams: any,SelTextAnalysis: any,exclude_stopwd: any,filename: any,username: any) {
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            "SelTopics": SelTopics,
            "SelWordFrequency" : SelWordFrequency,
            "SelNgrams": SelNgrams ,
            "SelTextAnalysis" : SelTextAnalysis ,
            "exclude_stopwd" : exclude_stopwd ,
            "FileName":filename,
            "Username":username

        });
        return this.http.post(this.configData + "getTopicModelling", body,{ 'headers': requestHeader });
      
    }


    GetuserDataVariables(auth_token: any,filename: any) {
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            "FileName": filename,

        });
        return this.http.post(this.configData + "GetUserVariables", body,{ 'headers': requestHeader });
      
    }

    GetDataVariables(auth_token: any) {

        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            

        });
        return this.http.post(this.configData + "GetVariables", body,{ 'headers': requestHeader });
      
    }


    public GetDataForFiltersForUser(auth_token: any,colname: string,Filters: string,filename: string) {
        const requestHeader = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        var body = JSON.stringify({
            "col": colname ,
            "UserKey": Filters,
            "Filename": filename
           
        });
        //console.log(body);
        return this.http.post(this.configData + "DistinctValForUserFilter", body,{ 'headers': requestHeader });
       
    }

    
    submitJobProfileData(auth_token: any,formData: any,aqchecked:boolean){
    
        const requestHeader = new HttpHeaders({
            // 'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer '+ `${auth_token}`,
            'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
           
        });
        if(aqchecked)
        {
            return this.http.post(this.configData + "JobProfileMatchingAQ", formData,{
                'headers':requestHeader
                // reportProgress: true,
                // observe: 'events'
            } );
        }
        else
        {
        return this.http.post(this.configData + "JobProfileMatching", formData,{
            'headers':requestHeader
            // reportProgress: true,
            // observe: 'events'
        } );
    }
    
    }

GetDataForSentimentAnalysis(auth_token:any,formData:any){
    const requestHeader = new HttpHeaders({
        //'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer '+ `${auth_token}`,
        'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
       
    });
    return this.http.post(this.configData + "analyzesentiment", formData,{ 'headers': requestHeader });
      

}
InsertUser(auth_token:any,formData:any){
    const requestHeader = new HttpHeaders({
        //'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer '+ `${auth_token}`,
        'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
       
    });
    this.mainusername = formData.get("username")
    console.log(this.mainusername)
    return this.http.post(this.configData + "UserLogging", formData,{ 'headers': requestHeader });
      

}
getusername()
{

    return this.mainusername

}

InsertUser_nlp(auth_token:any,formData:any){
    const requestHeader = new HttpHeaders({
        //'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer '+ `${auth_token}`,
        'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
       
    });
    return this.http.post(this.configData + "UserLogging_nlp", formData,{ 'headers': requestHeader });
      

}

getaccesslevel_jobprofile(auth_token:any,formData:any){
    const requestHeader = new HttpHeaders({
        //'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer '+ `${auth_token}`,
        'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
       
    });
   // formData.append("username", this.mainusername);
    //console.log('username')
   // console.log(formData.get("username"))
    return this.http.post(this.configData + "getaccesslevel_jobprofile",formData,{
        'headers':requestHeader,
        // 'reportProgress': true,
        // 'observe': 'events'
    } );
      

} 

GetdataforTheme(auth_token:any,formData:any){
    const requestHeader = new HttpHeaders({
        //'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer '+ `${auth_token}`,
        'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
       
    });
    return this.http.post(this.configData + "analyzesentiment", formData,{ 'headers': requestHeader });
      

}

public GetDataAfterLemmatization(auth_token:any,data:any){
    const requestHeader = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+ `${auth_token}`,
        'access-control-allow-origin': 'Origin, Content-Type, X-Auth-Token'
       
    });
    var body=JSON.stringify(data)

    return this.http.post(this.configData + "lemmatizewordcloud", body,{ 'headers': requestHeader });
   
}

    

}
